/* @ngInject */
export function SelectProtectiveEquipmentTypeController($ngRedux, ProtectiveEquipmentService, $scope) {
    var ctrl = this;
    var unsubscribe = angular.noop;

    ctrl.$onInit = function() {
        unsubscribe = $ngRedux.connect(mapStateToThis, {})(this);
        ctrl.options = [];

        $scope.$watch(
            () => ctrl.location,
            function(newLocation) {
                if (newLocation && newLocation.uuid) {
                    ProtectiveEquipmentService.getPersonalEquipmentTypes(newLocation.uuid)
                        .then(function(items) {
                            ctrl.options = items;
                        });
                }
            }
        );
    };

    ctrl.$onDestroy = function() {
        unsubscribe();
    };

    ctrl.onSelect = function() {
        if (ctrl.selectedOption) {
            $ngRedux.dispatch({
                type: 'EQUIPMENT_TYPE_SELECTED',
                id: ctrl.identifier,
                equipmentType: ctrl.selectedOption
            });
        }
    };

    function mapStateToThis(state) {
        return {
            selectedOption: state.protectiveEquipment[ctrl.identifier].filter.type,
            location: state.protectiveEquipment[ctrl.identifier].filter.location
        };
    }
}
